import { render, staticRenderFns } from "./MiniaturaChat.vue?vue&type=template&id=68b89be5&scoped=true&lang=pug&"
import script from "./MiniaturaChat.vue?vue&type=script&lang=js&"
export * from "./MiniaturaChat.vue?vue&type=script&lang=js&"
import style0 from "./MiniaturaChat.vue?vue&type=style&index=0&id=68b89be5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b89be5",
  null
  
)

export default component.exports